module.exports = __webpack_public_path__ + "assets/img/gal_03.31826737.jpg";